import React from 'react';
import { LandingLayout } from 'components/Landing/LandingLayout';
import { getLanguageInfo } from 'services/LanguageService';
import { useTranslation } from 'react-i18next';

interface AvailableLanguagesProps {
  translations: string[];
}

const AvailableLanguages: React.FC<AvailableLanguagesProps> = ({
  translations,
}) => {
  const { t } = useTranslation();

  if (!translations?.length) {
    return null;
  }

  const localizedNames = translations.map(
    (lang) => getLanguageInfo(lang)?.localName || lang,
  );

  return (
    <>
      <LandingLayout.ContentHeading>
        {t('Available languages')}
      </LandingLayout.ContentHeading>
      <LandingLayout.ContentText data-testid="language-test">
        {localizedNames.map((name, index) => (
          <span key={name}>
            {name}
            {index < localizedNames.length - 1 && ', '}
          </span>
        ))}
      </LandingLayout.ContentText>
    </>
  );
};

export default AvailableLanguages;
